import { InsertDriveFile } from "@mui/icons-material";
import { Chip, Grid2 } from "@mui/material";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import downloadAttachment from "../../../../Actions/downloadAttachment";
import { EMPTY_MARK, safeJSONParse } from "../../../../Actions/utils";

const Attachs = ({ hasAttachments, attachments }) => {
  const { auth, dispatch, settings } = useUIBp();

  const parsed =
    typeof attachments === "string" ? safeJSONParse(attachments, []) : attachments;
  const list = Array.isArray(parsed) ? parsed : [];

  if (!hasAttachments || !list.length) {
    return null;
  }

  const Attachments = list.map((data, idx) => {
    const onClick = () => {
      dispatch(
        downloadAttachment({
          ...auth,
          id: data?.id,
          name: data?.name,
          locale: settings.locale,
        })
      );
    };
    return (
      <Chip
        {...{
          key: data?.id ?? idx,
          onClick,
          icon: <InsertDriveFile />,
          label: data?.name || EMPTY_MARK,
        }}
      />
    );
  });

  return (
    <Grid2
      container
      {...{
        gap: 2,
        padding: 2,
        size: 12,
        sx: { borderTop: "1px solid lightgrey" },
      }}
    >
      {Attachments}
    </Grid2>
  );
};

export default Attachs;
